module.exports = __webpack_public_path__ + "static/media/tau.f68acb20.svg";